export default __webpack_public_path__ + "img/fBlWwoiF.d45d022c.svg";